var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreadmill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 2C20.75 1.58579 20.4142 1.25 20 1.25C19.5858 1.25 19.25 1.58579 19.25 2V5.45943L13.7628 7.28849C13.3699 7.41947 13.1575 7.84421 13.2885 8.23717C13.4195 8.63013 13.8442 8.8425 14.2372 8.71151L17.7637 7.53601L16.4444 16.1111L3.32523 18.735C2.55466 18.8891 2 19.5656 2 20.3515C2 21.2619 2.73807 22 3.64853 22H19C20.6569 22 22 20.6569 22 19V18.6594C22 17.3321 21.1487 16.2375 20 15.8296V6.79057L20.2372 6.71151C20.5434 6.60943 20.75 6.32282 20.75 6V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreadmill);
export default __webpack_public_path__ + "static/media/treadmill.411442cbf2b45d88fd563c6dc2dadd83.svg";
export { ForwardRef as ReactComponent };